import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './index.less';


const icons = ReactQuill.Quill.import("ui/icons");
icons["undo"] = `<svg viewbox="0 0 18 18">
<polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
<path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
</svg>`;;
icons["redo"] = `<svg viewbox="0 0 18 18">
<polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
<path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
</svg>`;


@withTranslation(["common"])
class QuillEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: this.props.content,
            editorRef: React.createRef()
        }
    }

    componentDidMount() {
        this.props.onRef && this.props.onRef(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    insertVariable = (value) => {
        const quill = this.state.editorRef.current.getEditor();
        quill.focus();
        const index = quill.getSelection().index || 0;
        quill.insertText(index, `{${value}}`);
    };

    handlePaste = (e) => {
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('text');
        if (this.isLink(pastedData)) {
            const quill = editorRef.current.getEditor();
            quill.focus();
            const index = quill.getSelection().index || 0;
            quill.insertText(index, pastedData, 'link', pastedData);
            e.preventDefault();
        }
    };
    isLink = (text) => {
        const urlRegex = /^(https?:\/\/)?([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63})(:[0-9]{1,5})?(\/[^\s]*)?$/i;
        return urlRegex.test(text);
    };
    render() {
        const { content, editorRef } = this.state;
        return <ReactQuill
            theme="snow"
            value={content}
            onChange={this.props.onChange}
            ref={editorRef}
            onPaste={this.handlePaste}
            modules={{
                history: {
                    delay: 2000,
                    maxStack: 500,
                    userOnly: true
                },
                toolbar: {
                    container: [
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        ['link'],
                        ['undo', 'redo']
                    ],
                    handlers: {
                        undo: function (value) {
                            this.quill.history.undo();
                        },
                        redo: function (value) {
                            this.quill.history.redo();
                        }
                    }
                }
            }}
        />
    }


}
export default QuillEditor;